import {
  AuthGuardService,
  LoginAuthGuardService,
  PaymentAuthGuardService,
} from "@tendercuts/providers";
import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    loadChildren: "./login/login.module#LoginPageModule",
    canActivate: [LoginAuthGuardService],
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "payment",
    loadChildren: "./home/payment/payment.module#PaymentPageModule",
    canActivate: [PaymentAuthGuardService],
  },
  {
    path: "orders",
    loadChildren:
      "./home/orders-history/orders-history.module#OrdersHistoryPageModule",
    canActivate: [AuthGuardService],
  },
  {
    path: "oos",
    loadChildren:
      "./home/oos-products/oos-products.module#OosProductsPageModule",
    canActivate: [AuthGuardService],
  },
  {
    path: "carry-bag",
    loadChildren:
      "./home/carry-bag-dashboard/carry-bag-dashboard.module#CarryBagPageModule",
    canActivate: [AuthGuardService],
  },
  {
    path: "pickup-orders",
    loadChildren:
      "./home/pickup-order/pickup-order.module#PickUpOrderPageModule",
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
  providers: [AuthGuardService, LoginAuthGuardService, PaymentAuthGuardService],
})
export class AppRoutingModule {}
